import React from "react";
import { StarIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { testimonials } from "../data/page";
export function TestimonialsSection() {
  return <section className="bg-surface px-4 py-16 sm:px-6 sm:py-24" data-id="element-339" data-mp="1mzivt9l22tot">
      <div className="mx-auto max-w-6xl" data-id="element-340" data-mp="1r146qpe14xwd">
        <SectionHeading title="What healthcare professionals may value in a resource like this" subtitle="A more organized way to review diabetic foot assessment concepts." data-id="element-341" data-mp="1qzt10k10xg2m" />

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-342" data-mp="1i28yl7rfddqf">
          {testimonials.map((t, i) => <figure key={t.role} className={`flex flex-col rounded-3xl bg-white p-6 shadow-sm ring-1 ring-navy-900/5 ${i === 0 ? "lg:col-span-2" : ""}`} data-id="element-343" data-mp="143j1vt8ipg2l" data-mpi={i}>
              <div className="flex items-center gap-4" data-id="element-344" data-mp="32hawkw8gb9e2">
                <img src={t.image} alt={`Portrait of ${t.role.toLowerCase()}`} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-accent-soft" loading="lazy" data-id="element-345" data-mp="32eop0wlk8tvu" />
                <div data-id="element-346" data-mp="34qcf2j1ha60c">
                  <figcaption className="text-lg font-bold leading-tight text-ink" data-id="element-347" data-mp="34qm6mb268l85">{t.role}</figcaption>
                  <div className="mt-1 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-348" data-mp="2zt2qt6pts0e3">
                    {Array.from({
                  length: 5
                }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-cta text-cta" aria-hidden="true" data-id="element-349" data-mp="27458x4pj05lv" data-mpi={s} />)}
                  </div>
                </div>
              </div>
              <blockquote className={`mt-5 leading-relaxed text-ink ${i === 0 ? "text-lg" : "text-base"}`} data-id="element-350" data-mp="2h22ypwn1aagl">
                “{t.quote}”
              </blockquote>
              <p className="mt-auto pt-5 text-xs text-ink-soft" data-id="element-351" data-mp="18u9yjd3bd3m">Illustrative sample.</p>
            </figure>)}
        </div>

        <div className="mt-12" data-id="element-352" data-mp="3f0w1ox7c4y2">
          <CtaButton label="Get your complete blueprint" data-id="element-353" data-mp="3dqwevapaopb" />
        </div>
      </div>
    </section>;
}